import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { useCurrency } from '../utils/useCurrency';
export function UrgencySection() {
  // 15 minutes in seconds
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const {
    formatPrice,
    isLoading
  } = useCurrency();
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section className="py-12 px-6" data-id="element-212">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="relative overflow-hidden bg-gradient-to-br from-white to-[#FDFBF7] rounded-3xl p-8 md:p-10 shadow-[0_20px_40px_-15px_rgba(201,166,107,0.25)] border border-copper/20" data-id="element-213">
        {/* Subtle warm glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#D4B896]/10 to-transparent pointer-events-none" data-id="element-214" />

        <div className="relative z-10 flex flex-col items-center text-center" data-id="element-215">
          {/* Header with pulsing dot */}
          <div className="flex items-center gap-2.5 mb-8 bg-[#F8F5F0] px-4 py-1.5 rounded-full border border-copper/10 shadow-sm" data-id="element-216">
            <span className="relative flex h-2.5 w-2.5" data-id="element-217">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#B87333] opacity-60" data-id="element-218"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#B87333]" data-id="element-219"></span>
            </span>
            <span className="font-inter text-[11px] font-bold tracking-[0.15em] uppercase text-copper" data-id="element-220">
              Limited Time Offer
            </span>
          </div>

          {/* Timer Display */}
          <div className="flex items-center justify-center gap-4 md:gap-6 mb-10" data-id="element-221">
            <div className="flex flex-col items-center" data-id="element-222">
              <div className="relative overflow-hidden bg-gradient-to-b from-[#F8F5F0] to-white text-copper font-playfair text-5xl md:text-6xl font-medium w-20 h-24 md:w-24 md:h-28 flex items-center justify-center rounded-2xl shadow-[0_8px_20px_rgba(201,166,107,0.15),inset_0_2px_4px_rgba(255,255,255,0.8)] border border-copper/20" data-id="element-223">
                <div className="absolute top-0 left-0 w-full h-1/2 bg-white/40 border-b border-copper/5" data-id="element-224" />
                <span className="relative z-10 drop-shadow-sm" data-id="element-225">
                  {minutes.toString().padStart(2, '0')}
                </span>
              </div>
              <span className="font-inter text-[10px] uppercase tracking-[0.2em] text-copper/60 mt-3 font-semibold" data-id="element-226">
                Minutes
              </span>
            </div>

            <div className="text-copper/40 text-5xl font-playfair mb-8 animate-pulse" data-id="element-227">
              :
            </div>

            <div className="flex flex-col items-center" data-id="element-228">
              <div className="relative overflow-hidden bg-gradient-to-b from-[#F8F5F0] to-white text-copper font-playfair text-5xl md:text-6xl font-medium w-20 h-24 md:w-24 md:h-28 flex items-center justify-center rounded-2xl shadow-[0_8px_20px_rgba(201,166,107,0.15),inset_0_2px_4px_rgba(255,255,255,0.8)] border border-copper/20" data-id="element-229">
                <div className="absolute top-0 left-0 w-full h-1/2 bg-white/40 border-b border-copper/5" data-id="element-230" />
                <span className="relative z-10 drop-shadow-sm" data-id="element-231">
                  {seconds.toString().padStart(2, '0')}
                </span>
              </div>
              <span className="font-inter text-[10px] uppercase tracking-[0.2em] text-copper/60 mt-3 font-semibold" data-id="element-232">
                Seconds
              </span>
            </div>
          </div>

          {/* Copy */}
          <p className="font-inter text-charcoal text-base md:text-lg leading-relaxed max-w-sm font-light" data-id="element-233">
            This offer{' '}
            <span className="font-medium text-copper" data-id="element-234">
              only exists on this page
            </span>
            .
            <br className="hidden md:block" data-id="element-235" />
            Once you leave, the price returns to{' '}
            <span className="line-through opacity-40" data-id="element-236">
              <span className={`transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-237">
                {formatPrice(67, true)}
              </span>
            </span>
            .
          </p>

          <div className="mt-8 inline-flex items-center gap-2 text-copper/70 font-inter text-xs tracking-wide uppercase" data-id="element-238">
            <ClockIcon className="w-3.5 h-3.5" data-id="element-239" />
            No exceptions
          </div>
        </div>
      </motion.div>
    </section>;
}